<template>
  <div 
      class="flex flex-col items-center text-center 
        lg:items-start lg:text-left lg:flex-row-reverse lg:justify-around">
    <div>
      <a 
        href="https://github.com/upsidefrown/fasload"
        target="_blank">
        <img 
          src="../../assets/demo.gif"
          alt="fasload"
          class="pt-2 px-12 sm:px-4 sm:pt-8 lg:px-0"/></a>
    </div>
    <div>
      <h1
        class="font-display text-6xl sm:text-display text-red-300 font-medium tracking-wider pt-12 lg:pt-0">
        fasload</h1>
      <p
        class="text-gray-300 text-xl lg:text-2xl px-8 sm:px-16 lg:w-3/4 lg:px-0 font-light leading-relaxed">
        A <strong class="text-red-100">simple</strong>, <strong class="text-red-100">cross platform</strong>, <strong class="text-red-100">benchmarking</strong> tool for testing RESTful services under load. The motivation for this project arose from the cumbersome nature of configuring test requests via the command line.</p>
      <div
        class="flex justify-center lg:justify-start space-x-3 text-xl text-red-400 py-12 tracking-wide font-medium font-display">
        <a
          href="https://github.com/upsidefrown/fasload"
          target="_blank"
          class="flex">
          <font-awesome-icon
          class="text-2xl sm:text-3xl hover:text-red-100 mr-4"
          :icon="['fab', 'github-alt']" /></a>
        <a 
          href="https://www.electronjs.org/" 
          target="_blank"
          class="flex text-lg sm:text-xl hover:text-red-100 hover:font-medium">Electron</a>
        <span class="text-lg sm:text-xl">•</span>
        <a 
          href="https://nodejs.org/" 
          target="_blank"
          class="flex text-lg sm:text-xl hover:text-red-100 hover:font-medium">Node</a>
        <span class="text-lg sm:text-xl">•</span>
        <a 
          href="https://vuejs.org/" 
          target="_blank"
          class="flex text-lg sm:text-xl hover:text-red-100 hover:font-medium">Vue</a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Projects'
  }
</script>
